import request from '../../../../../shared/lib/request';
import { API } from '../../../../../shared/constants';


const getOccupazione = () => request(
  {
    url: API.OCCUPAZIONE,
    method: 'GET',
  });

const getOccupazioneOptions = () => getOccupazione().then(
    (res) => res._embedded.occupazione.map((obj)=>{ return {value: obj.id, label: obj.nome }}) // eslint-disable-line
  ).then((data) => ({ options: data }));


const OccupazioneService = {
  getOccupazione,
  getOccupazioneOptions,
};

export default OccupazioneService;



// WEBPACK FOOTER //
// ./app/shared/services/api/anagrafica/occupazione/index.js